<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Liste des parcours</h3>
    <!-- <div hlmCardAction>
      <button (click)="creerReferentiel()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Créer un parcours
      </button>
    </div> -->
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Nom</th>
            <th hlmTh style="min-width: 128px">Référentiel</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (item of parcoursAll(); track item.id) {
            <tr hlmTr>
              <td hlmTd>{{ item.nom }}</td>
              <td hlmTd>{{ item.referentiel?.nom }}</td>
              <td hlmTd>
                <button
                  (click)="editerParcours(item)"
                  aria-label="Éditer le parcours"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                  hlmTooltipTrigger="Éditer le parcours"
                >
                  <ng-icon name="lucidePen" />
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <app-paginateur [store]="parcoursStore" />
    </div>
  </div>
</section>
